import { Box } from "@mui/material";
import React from "react";
import Sidebar from "../../../components/sidebar/sidebar";
import { Helmet } from "react-helmet";
import ScratchAndWinGame from "../../../components/Menus/autoGames/scracthAndWin";

function ScratchAndWin() {
  return (
    <>
      <Helmet>
        <title>S - M ( M-India ) Spot-Money | ScratchAndWin</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          maxWidth: "100vw",
          height: "100dvh",
          overflow: "hidden",
        }}
      >
        <Sidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            maxWidth: "100%",
            overflowX: "hidden",
            overflowY: "auto",
            height: "100dvh",
            minHeight: 0,
            boxSizing: "border-box",
            p: 1,
            background: `url(${process.env.PUBLIC_URL}/images/logo-background.png) center/250px no-repeat fixed `,
          }}
        >
          <Box height={{ xs: 60, md: 90 }} />

          {/* games */}
          <Box sx={{ px: { xs: 0.5, sm: 1.5, md: 2.5 } }}>
            <ScratchAndWinGame />
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default ScratchAndWin;
